import React, { Component } from 'react';
import SmartModal from '@common/components/modals/smartModal';
import { Modal } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { connect } from '@common/components/base.component';
import DDados from '../emissao.ddados';
import EmissaoForm from './emissao.form';

class Container extends Component {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }

  imprimirRelatorioModal(item) {
    this.props.fecharModal(item);
  }

  render() {
    const { componentUrl, selecaoItens, show, onCancel } = this.props;

    return (
      <SmartModal
        show={show}
        size="lg"
        autoFocus={false}
        keyboard
        onHide={onCancel}
        enforceFocus={false}
        backdrop="static"
        style={{ width: '100vw' }}
      >
        <Modal.Header>
          <Modal.Title>
            <h2>Imprimir Relatório</h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <EmissaoForm
            componentUrl={componentUrl}
            selecaoItens={selecaoItens}
            onCancel={this.props.onCancel}
            modulo={this.props.modulo}
          />
        </Modal.Body>
      </SmartModal>
    );
  }
}

export default connect({})(Container);
